import React, { Fragment } from "react";
import { withStyles } from "@material-ui/core/styles";
import { FusePageSimple } from "@fuse";
import { withRouter } from "react-router";
import UserManagementTable from "./UserManagementTable";
import Paper from "@material-ui/core/Paper";
import InviteUserModal from './InviteUserModal';
import Button from "@material-ui/core/Button";
import axiosInstance from "../common/AxiosInstace";
import EndpointsGetter from '../common/EndpointsGetter';
import { filterObj } from './user-management-util';
import CircularProgress from '@material-ui/core/CircularProgress';
import classNames from 'classnames';
import SnackBar from '../common/Snackbar';
import ConfirmationDialog from '../common/ConfirmationDialog';
import { connect } from 'react-redux';
import { getUserData } from '../../../store/selectors';
import PropTypes from 'prop-types';

const styles = theme => ({
    layoutRoot: {},
    circularProgress: {
        'position': 'absolute', 'z-index': '1', 'margin-left': 'auto', 'margin-right': 'auto', 'top': '50%', 'left': '50%'
    }
});

class UserManagement extends React.Component {
    state = {
        inviteModalShow: false,
        userData: {
            totalPages: 0,
            totalElements: 0,
            elements: [],
            errorString: '',
            forbidAllActions: false
        },
        showMessage: false,
        showConfirmDialog: false,
        confirmDialog: {},
        successMessage: '',
    };

    componentDidMount() {
        let accessToken = localStorage.getItem("access_token");
        if (accessToken == null || typeof accessToken == "undefined") {
            this.props.history.push('/login');
        } else {
            this.getUsers(filterObj);
        }
    }

    getUsers = (filter) => {
        let accessToken = localStorage.getItem("access_token");
        axiosInstance.post(`${EndpointsGetter.getUsersEndpoint()}`, filter, {
            headers: {
                'Authorization': 'Bearer ' + accessToken
            }
        })
            .then(response => {
                let data = response.data;
                let elements = data.elements.map(element => {
                    return {
                        ...element,
                        lastLoginTs: element.lastLoginTs != null ? element.lastLoginTs.split("T")[0] : ''
                    }
                });
                data.elements = elements;
                this.setState({ userData: data, forbidAllActions: false });
            })
            .catch(error => {
                this.getError(error);
            });
    };

    toggleWholeScreenLoader = (flag) => {
        this.setState({ forbidAllActions: flag });
    }

    toggleModal = () => {
        this.setState({ inviteModalShow: !this.state.inviteModalShow });
    }

    showMessage = (successMessage) => {
        this.setState({ showMessage: !this.state.showMessage, successMessage: successMessage });
    }

    handleClose = () =>
        this.setState({ showConfirmDialog: false, confirmDialog: {} })

    handleConfirm = () => {
        this.state.confirmDialog.handleConfirm();
        this.setState({  showConfirmDialog: false, confirmDialog: {}  });
    }

    openConfirmationDialog = (confirmDialog) => {
        this.setState({ showConfirmDialog: true, confirmDialog: confirmDialog });
    }

    getError(error) {
        let errorString = '';
        if (error.code === 'ECONNABORTED') {
            errorString = "API Request timed out. Please try again after few seconds";
        } else if (error.response.status === 500) {
            errorString = "Operation was unsuccessful. Please try again after few seconds";
        } else if (error.response.status === 404) {
            errorString = "Error 404";
        } else if (error.response.status === 401) {
            // errorString = "Unauthorized";
        } else {
            errorString = error.response.data.message ? error.response.data.message : error.response.data.error_description;
            if (error.response.status === 400 && errorString.includes("Invalid refresh token")) {
                this.props.history.push('/login');
            }
        }
        let oldState = { ...this.state };
        oldState.errorString = errorString;
        oldState.forbidAllActions = false;
        this.setState(oldState);
    }

    render() {
        const { classes, user } = this.props,
            { inviteModalShow, userData, errorString, forbidAllActions, showMessage, successMessage, showConfirmDialog } = this.state,
            { message, handleConfirm } = this.state.confirmDialog;

        return (
            <div>
                {forbidAllActions ? <CircularProgress className={classNames(classes.circularProgress, classes.progress)} color="secondary" /> : null}
                <div style={{ pointerEvents: forbidAllActions ? 'none' : 'auto', 'filter': forbidAllActions ? 'blur(1px)' : 'blur(0px)' }}>
                    <FusePageSimple
                        classes={{
                            root: classes.layoutRoot
                        }}
                        header={
                            <div className='header-container'>
                                <div>
                                    <h3 className='header-title'>User Management</h3>
                                </div>
                            </div>
                        }
                        content={
                            <div className="p-24">
                                {errorString ? (
                                    <label className="text-area-label col-lg-6" style={{ color: 'red', padding: '0' }}>
                                        {errorString}
                                    </label>
                                ) : null}

                                <div className="flex flex-row-reverse mb-16">
                                    <div className="float-right">
                                        <Button variant="outlined" color="secondary" onClick={this.toggleModal}>Invite user</Button>
                                    </div>
                                </div>
                                <Paper>
                                    <UserManagementTable
                                        userData={userData}
                                        getAllUsersCallback={this.getUsers}
                                        errorCallback={this.getError}
                                        toggleLoader={this.toggleWholeScreenLoader}
                                        openConfirmationDialog={this.openConfirmationDialog}
                                        showMessage={this.showMessage}
                                        user={user}
                                    />
                                </Paper>
                                <InviteUserModal
                                    inviteModalShow={inviteModalShow}
                                    toggleModal={this.toggleModal}
                                    showMessage={this.showMessage}
                                />
                            </div>
                        }
                    />
                </div>
                <SnackBar
                    open={showMessage}
                    duration={3000}
                    message={successMessage}
                    variant='success'
                    handleClose={() => this.setState({ showMessage: false, successMessage: '' })}
                />
                <ConfirmationDialog
                    open={showConfirmDialog}
                    message={message ? message : ''}
                    handleConfirm={this.handleConfirm}
                    handleClose={this.handleClose}
                />
            </div>
        );
    }
}

UserManagement.propTypes = {
    classes: PropTypes.object.isRequired,
    user: PropTypes.object
};

const mapStateToProps = (state) => {
    const userData = getUserData(state).user;
    return {
        user: userData
    };
}

export default withStyles(styles, {withTheme: true})(withRouter(connect(mapStateToProps, null)(UserManagement)));


// WEBPACK FOOTER //
// ./src/main/content/user-management/UserManagement.js